import * as types from '../actionType';

export default function loading(state = false, action) {
  switch (action.type) {
    case types.ADMIN_LOGIN_REQUEST:
    case types.STAFF_LIST_REQUEST:
    case types.ADD_NEXT_WORK_TIME_REQUEST:
    case types.ATTENDANCE_SHEET_REQUEST:
    case types.EXPECTED_WORK_SHEET_REQUEST:
    case types.EXPECTED_WORKBYDAY_SHEET_REQUEST:
    case types.ALL_ATTENDANCE_SHEET_REQUEST:
    case types.ADJUSTMENT_SCHEDULE_SHEET_REQUEST:
    case types.RE_ADD_STAFF_WORK_RECORD_REQUEST:
    case types.ADJUSTMENT_SCHEDULE_SHEET_DETAIL_REQUEST:
    case types.FETCH_START:
      return true;
    case types.ADMIN_LOGIN_SUCCESS:
    case types.ADMIN_LOGIN_FAILURE:
    case types.STAFF_LIST_SUCCESS:
    case types.STAFF_LIST_FAILURE:
    case types.ADD_NEXT_WORK_TIME_SUCCESS:
    case types.ADD_NEXT_WORK_TIME_FAILURE:
    case types.ATTENDANCE_SHEET_SUCCESS:
    case types.ATTENDANCE_SHEET_FAILURE:
    case types.EXPECTED_WORKBYDAY_SHEET_SUCCESS:
    case types.EXPECTED_WORKBYDAY_SHEET_FAILURE:
    case types.EXPECTED_WORK_SHEET_SUCCESS:
    case types.EXPECTED_WORK_SHEET_FAILURE:
    case types.ALL_ATTENDANCE_SHEET_SUCCESS:
    case types.ALL_ATTENDANCE_SHEET_FAILURE:
    case types.ADJUSTMENT_SCHEDULE_SHEET_SUCCESS:
    case types.ADJUSTMENT_SCHEDULE_SHEET_FAILURE:
    case types.RE_ADD_STAFF_WORK_RECORD_SUCCESS:
    case types.RE_ADD_STAFF_WORK_RECORD_FAILURE:
    case types.ADJUSTMENT_SCHEDULE_SHEET_DETAIL_SUCCESS:
    case types.ADJUSTMENT_SCHEDULE_SHEET_DETAIL_FAILURE:
    case types.FETCH_END:
      return false;
    default:
      return state;
  }
}
